import React from "react";
import ProfileTabs from "./ProfileTabs";
import { Header } from "semantic-ui-react";

const SystemAccess = (props) => {
  return (
    <div className="table-overflow p-1 flex-stretch-vertical">
      <Header>User System Access Profile - {props.profileName}</Header>
      <ProfileTabs
        cms={props.cms}
        cmsMobile={props.cmsMobile}
        siteController={props.siteController}
      />
    </div>
  );
};

export default SystemAccess;
